  <div class="feedback-sent-box" (click)="handleBodyClick()"
         data-testid="FeedbackNotificationBody">
        <div class="feedback-sent-orange-div"></div>
        <div class="feedback-sent-text-block h4Font" i18n>
            {{ "THANKS_FOR_YOUR_FEEDBACK" | translate }}!
        </div>
  </div>
